import { ease } from "./timeline";

/** Seconds relative to the outro; start after centering and the artwork reveal. */
export const getPenguinWaveAngle = (seconds: number) => {
  if (seconds <= 0.75 || seconds >= 1.6) return 0;
  const lift = ease((seconds - 0.75) / 0.18);
  const lower = 1 - ease((seconds - 1.43) / 0.17);
  const waveProgress = Math.max(0, Math.min(1, (seconds - 0.93) / 0.5));
  // Two gentle flaps, with zero velocity at each end of the greeting.
  const flap = 18 * (1 - Math.cos(waveProgress * Math.PI * 4)) / 2;
  return (-100 + flap) * lift * lower;
};
